var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"defaultV2",attrs:{"id":"app"}},[_c('v-content',{staticClass:"app-container"},[_c('v-container',[_c('transition',{attrs:{"name":"slide-fade"}},[_c('nuxt')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }